/**
 * Inputs: save acknowledgement + the card id we intended to persist.
 * Outputs: whether the form may clear, or must keep the draft.
 */

import type { ThaiPhrase, TripDocument } from "./schema.ts";

export type PhraseSaveAck =
  | { ok: true; trip: TripDocument }
  | { ok: false; kind: string; message: string };

export function interpretPhraseSaveAck(
  result: PhraseSaveAck | void | null,
  focusId?: string,
): { ok: true; phrases: ThaiPhrase[] } | { ok: false; message: string } {
  if (!result || typeof result !== "object") {
    return { ok: false, message: "Save did not confirm. This card is still only on this phone." };
  }
  if (!("ok" in result) || result.ok !== true) {
    const message = "message" in result && typeof result.message === "string"
      ? result.message
      : "Could not save the card.";
    return { ok: false, message };
  }
  if (!result.trip || !Array.isArray(result.trip.thaiPhrases)) {
    return { ok: false, message: "Save reply was incomplete. This card is still only on this phone." };
  }
  if (focusId && !result.trip.thaiPhrases.some((phrase) => phrase.id === focusId)) {
    return { ok: false, message: "The saved trip did not include this card. Nothing was cleared." };
  }
  return { ok: true, phrases: result.trip.thaiPhrases };
}
